import { useState } from "react";
import { observer } from "mobx-react";
import Dashboard from "views/app/dashboard/index.jsx";
import Providers from "views/app/providers/index.jsx";
import History from "views/app/tigo-gestion/history/index.jsx";

export default observer(function TigoGestion(props) {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'providers', label: 'Proveedores', icon: '📋' },
    { id: 'history', label: 'Historial', icon: '📜' }
  ];

  return (
    <>
      <div className="p-2 max-w-7xl mx-auto text-black">
        {/* Tabs Navigation */}
        <div className="flex border-b border-gray-300 mb-6 gap-0">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-3 font-medium transition-all border-b-2 ${
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-600 hover:text-gray-800'
              }`}
            >
              <span className="text-lg mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="w-full">
          {activeTab === 'dashboard' && (
            <div className="animate-fadeIn">
              <Dashboard {...props} />
            </div>
          )}

          {activeTab === 'providers' && (
            <div className="animate-fadeIn">
              <Providers {...props} />
            </div>
          )}

          {activeTab === 'history' && (
            <div className="animate-fadeIn">
              <History {...props} />
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-in-out;
        }
      `}</style>
    </>
  );
});
